module.exports = __webpack_public_path__ + "media/images/button-small-grey-sprite-55e19571.png";